export const menuItems = [
    {
        id: 2,
        label: "menuitems.dashboards.text",
        icon: "bx-home-circle",
        link: "/",
        /*badge: {
            variant: "info",
            text: "menuitems.dashboards.badge"
        }*/
    },
    {
        id: 3,
        isLayout: true
    },
    {
        id: 4,
        label: "menuitems.employee.text",
        icon: "bxs-user-detail",
        link: "/employee/list",
        forEmployee: true,
    },
    {
        id: 5,
        label: "menuitems.teams.text",
        icon: "bx-group",
        link: "/team/list"
    },
    {
        id: 6,
        label: "menuitems.rules.text",
        icon: "bx-clipboard",
        link: "/rules/list"
    },
    {
        id: 7,
        label: "menuitems.projects.text",
        icon: "bx-briefcase-alt-2",
        subItems: [
            {
                id: 17,
                label: "menuitems.projects.list.projects",
                link: "/projects/list",
                parentId: 12
            },
            {
                id: 18,
                label: "menuitems.projects.list.people",
                link: "/project/people",
                parentId: 12
            }
        ]
    },
    /*{
        id: 19,
        label: "menuitems.summary.text",
        icon: "bx-time",
        link: "/summary",
        forEmployee: true,
    },*/
    {
        id: 8,
        label: "menuitems.attendance.text",
        icon: "bx-time",
        link: "/attendance",
        forEmployee: true,
    },
    {
        id: 9,
        label: "menuitems.screenshots.text",
        icon: "bx-screenshot",
        link: "/screenshot",
        forEmployee: true,
    },
    /*{
        id: 19,
        label: "Remote Access",
        icon: "bx-video",
        link: "/remote",
        forEmployee: true,
    },*/
    {
        id: 10,
        label: "Integrations",
        icon: "bx-calendar",
        link: "/integrations",
        forEmployee: true,
        badge: {
            variant: "info",
            text: "Beta"
        }
    },
    {
        id: 10,
        label: "menuitems.calendar.text",
        icon: "bx-calendar",
        link: "/calendar",
        forEmployee: true,
    },
    {
        id: 12,
        label: "menuitems.reports.text",
        icon: "bx-trending-up",
        forEmployee: true,
        subItems: [
            {
                id: 13,
                label: "menuitems.reports.list.activity",
                link: "/reports/people",
                parentId: 12
            },
            {
                id: 14,
                label: "menuitems.reports.list.web",
                link: "/reports/web",
                parentId: 12
            },
            {
                id: 15,
                label: "menuitems.reports.list.application",
                link: "/reports/app",
                parentId: 12
            }
        ]
    },
    {
        id: 16,
        label: "menuitems.faq.text",
        icon: "bx-support",
        link: "/pages/faqs",
        forEmployee: true,
    }
];